export class ClaimDiagnosisDTO {
  lineNo: number;
  code: string;
  type: string;
  qualifier: string;
}
